<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{
      disabled: !isEdit,
    }"
  >
    <a-form
      :model="formState"
      :label-col="{ style: { width: '80px' } }"
      :wrapper-col="{ style: { width: '300px' } }"
      :rules="rules"
      ref="formRef"
      layout="inline"
    >
      <a-form-item name="snNumber" label="SN号">
        <a-input
          v-if="props.type === 'fqc'"
          allowClear
          v-model:value="formState.assembleDebugsnNumber"
          placeholder="请输入SN号"
          disabled
        />

        <a-input
          v-else-if="props.type === 'oqc'"
          allowClear
          v-model:value="formState.serial"
          disabled
        >
        </a-input>

        <a-input
          v-else
          allowClear
          v-model:value="formState.snNumber"
          placeholder="请输入SN号"
          disabled
        />
      </a-form-item>
      <a-form-item label="型号" name="model">
        <a-input
          v-model:value="formState.modelSpecifications"
          placeholder="请选择设备型号"
          disabled
        >
        </a-input>
      </a-form-item>

      <a-form-item label="生产批号" name="batchNumber">
        <a-input
          placeholder="请输入生产批号"
          v-model:value="formState.batchNumber"
          allowClear
          disabled
        ></a-input>
      </a-form-item>

      <!-- <a-form-item
        label="新设备"
        name="isNewDevice"
        v-if="props.type === 'fqc'"
      >
        <a-select
          v-model:value="formState.isNewDevice"
          placeholder="是否为新设备"
        >
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item label="送检次数" name="inspectionFrequency">
        <a-input-number
          placeholder="请输入送检次数"
          v-model:value="formState.inspectionFrequency"
          :step="1"
          style="width: 300px"
          allowClear
          :disabled="!isEdit"
        ></a-input-number>
      </a-form-item>

      <a-form-item label="状态" name="status">
        <a-select
          v-model:value="formState.status"
          placeholder="请选择送检状态"
          allowClear
          :disabled="!isEdit"
          @change="handleSelectStatus"
        >
          <a-select-option value="合格">合格</a-select-option>
          <a-select-option value="不合格">不合格</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="来源工序"
        name="sourceProcess"
        v-if="props.type !== 'fqc' && props.type !== 'oqc'"
      >
        <a-select
          v-model:value="formState.sourceProcess"
          placeholder="请选择来源工序"
          :options="PQCProductOption"
          allowClear
        >
        </a-select>
      </a-form-item>

      <a-form-item
        label="输出SN号"
        name="outputSnNumber"
        v-if="props.type !== 'fqc' && props.type !== 'oqc'"
      >
        <a-input
          v-model:value="formState.outputSnNumber"
          placeholder="请输入输出SN号"
          allowClear
        >
        </a-input>
      </a-form-item>

      <a-form-item label="质检">
        <question-vue
          ref="questionRef"
          title="送检问题"
          :disabled="!isEdit"
          :questionDesc="formState.inspectionIssues"
          :questionDisabled="formState.status === '合格'"
          :ROSAuthority="props.ROSAuthority"
          :type="props.type"
          style="width: 360px"
          @updateInspectionCount="updateInspectionCount"
        >
        </question-vue>
      </a-form-item>

      <a-form-item label="备注">
        <content-dsc-vue
          :question="formState.notes"
          ref="notesRef"
          :disabled="!isEdit"
          style="width: 360px"
        ></content-dsc-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { updatePQC } from "@/request/view/dailyQualityInspection";
import { updateFQC, updateOQC } from "@/request/view/warehouse";
import { PQCProductOption } from "@/views/productDaily/serve/option";
import { checkWarehouse } from "@/views/productDaily/components/quality/PQC/view/serve/condition";
import questionVue from "@/views/productDaily/components/quality/PQC/view/components/question.vue";
import contentDscVue from "@/views/productDaily/components/quality/PQC/view/components/note.vue";

export default defineComponent({
  components: { questionVue, contentDscVue },
  props: {
    ROSAuthority: Boolean,
    type: String,
  },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const notesRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const isWarehouse = ref(false);

    const formState = reactive({
      batchNumber: null,
      assembleDebugsnNumber: null,
      closedLoopStatus: null,
      id: null,
      inspectionFrequency: null,
      inspectionIssues: null,
      isNewDevice: null,
      localDate: null,
      modelSpecifications: null,
      serial: null,
      fqcId: null,
      notes: null,
      produceOrTpc: null,
      isToFQC: null,
      productionInstructionId: null,
      outputSnNumber: null,
      productionTaskId: null,
      serialNumber: null,
      snNumber: null,
      sourceProcess: null,
      status: null,
      subordinateProcess: null,
      type: null,
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (formState.userId === null) {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const checkStatus = async (rule, value) => {
      if (value === "合格" || value === "不合格") {
        return Promise.resolve();
      }
      return Promise.reject(rule.message);
    };

    const updateInspectionCount = (count) => {
      formState.inspectionFrequency = count;
    };

    const rules = reactive({
      inspectionFrequency: [
        {
          required: true,
          message: "请输入送检次数",
          trigger: "blue",
          type: "number",
        },
      ],
      status: [
        {
          required: true,
          message: "请选择状态",
          trigger: "change",
          // type: "string",
          validator: checkStatus,
        },
      ],
      sourceProcess: [
        {
          required: true,
          message: "请选择来源工序",
          trigger: "change",
          type: "string",
        },
      ],
      outputSnNumber: [
        {
          required: true,
          message: "请输入最终SN号",
          trigger: "change",
          type: "string",
        },
      ],
    });

    const handleSelectStatus = (e) => {
      if (
        props.type !== "threeMajorItems" &&
        props.type !== "girdling" &&
        props.type !== "detector" &&
        e === "不合格"
      ) {
        // rules.sourceProcess[0].required = true;
      } else if (e === "合格") {
        // rules.sourceProcess[0].required = false;
        rules.outputSnNumber[0].required = true;

        switch (props.type) {
          case "fqc":
            break;
          case "oqc":
            break;
          default:
            formState.outputSnNumber = formState.snNumber;
            break;
        }
      }

      if (e === "不合格") {
        rules.outputSnNumber[0].required = false;
        formState.outputSnNumber = null;
        formState.isWarehouse = null;
      }
    };

    const questionRef = ref();

    const resetForm = () => {
      // rules.sourceProcess[0].required = false;
      Object.keys(formState).keys((key) => {
        formState[key] = null;
      });
      formState.isWarehouse = null;
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (data) => {
      // rules.sourceProcess[0].required = false;
      Object.keys(formState).forEach((key) => {
        formState[key] = data[key];
      });

      if (!formState.outputSnNumber)
        formState.outputSnNumber = formState.snNumber;

      modalConfig.title = "编辑质检数据";
      modalConfig.visible = true;
    };

    const getReqData = () => {
      return new Promise((resolve, reject) => {
        if (questionRef.value) {
          questionRef.value
            .uploadFile()
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          resolve(null);
        }
      });
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            await getReqData()
              .then((res) => {
                console.log(res);
                formState.inspectionIssues = JSON.stringify(res);
              })
              .catch((err) => {
                console.log(err);
                throw new Error("上传错误，请稍后重试");
              });

            await notesRef.value
              .uploadFile()
              .then((res) => {
                formState.notes = JSON.stringify(res);
              })
              .catch((err) => {
                console.log(err, "备注上传出错");
              });
            const { id, username } = store.state.user.user;

            if (formState.userId === null && formState.username === null) {
              formState.userId = id;
              formState.username = username;
            }

            if (props.type === "fqc") {
              updateFQC(
                {
                  isQualityInspection: 1,
                },
                formState
              )
                .then((res) => {
                  let type = res.code === 200 ? "success" : "warning";
                  Toast(type, res.message, 3);
                  handleCancel();
                  context.emit("updateTable");
                })
                .catch((err) => {
                  console.log(err);
                });
              return;
            }

            if (props.type === "oqc") {
              updateOQC(formState)
                .then((res) => {
                  let type = res.code === 200 ? "success" : "warning";
                  Toast(type, res.message, 3);
                  handleCancel();
                  context.emit("updateTable");
                })
                .catch((err) => {
                  console.log(err);
                });
              return;
            }

            updatePQC(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                if (isWarehouse.value && props.type === "assembleDebug") {
                  context.emit("handleInsertWarehouse", formState);
                  return;
                }
                context.emit("updateTable");
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      props,
      rules,
      isEdit,
      formRef,
      notesRef,
      formState,
      questionRef,
      modalConfig,
      isWarehouse,
      PQCProductOption,
      checkWarehouse,
      updateInspectionCount,
      handleOk,
      handleSelectStatus,
      openModal,
      handleCancel,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 8px;
}
</style>
